import { createContext, useContext, useEffect, useRef, useState } from "react"
import { useAuth } from "../../auth/auth-provider/auth-provider";
import GetPriceMarkupTypes from "../../api-layer/price-markup-type-api/GetPriceMarkupTypes";

const PriceMarkupTypeContext = createContext();


const PriceMarkupTypeProvider = ({children}) => {
    const [priceMarkupTypes, setPriceMarkupTypes] = useState();
    const auth = useAuth()

     useEffect(() => {
       getPriceMarkupTypes();
    }, [auth?.token,])

    const getPriceMarkupTypes = () => {
        GetPriceMarkupTypes().then(
            res => {
                setPriceMarkupTypes(res.data);
            }
        ).catch(
            error => {
                setPriceMarkupTypes([]);
            }
        );
    }

    return (
        <>
            <PriceMarkupTypeContext.Provider
                value={{priceMarkupTypes}}
            >
                {children}
            </PriceMarkupTypeContext.Provider>
        </>

    ) ;
};

export default PriceMarkupTypeProvider;

export const usePriceMarkupTypes = () => {
    return useContext(PriceMarkupTypeContext);
};
